<tt-nav-bar></tt-nav-bar>
<tt-side-nav>
    <tt-app-breadcrumbs></tt-app-breadcrumbs>
    <ng-content></ng-content>
</tt-side-nav>
